const intFormatter = new Intl.NumberFormat(undefined, {
  maximumFractionDigits: 0,
});

const dec3Formatter = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 3,
  maximumFractionDigits: 3,
});

export type FormatNumberOptions = {
  /** When true, format with 0 fraction digits. Default is decimal (3 places). */
  asInteger?: boolean;
};

const formatWith = (value: unknown, formatter: Intl.NumberFormat): string => {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value as any);
  if (!Number.isFinite(n)) return String(value);
  return formatter.format(n);
};

export const formatNumberSmart = (value: unknown, options?: FormatNumberOptions): string => {
  return formatWith(value, options?.asInteger ? intFormatter : dec3Formatter);
};

export const formatInt = (value: unknown): string => formatNumberSmart(value, { asInteger: true });

export const formatDec3 = (value: unknown): string => formatNumberSmart(value);
